<template>
<button
    v-require-identity
    @click="toggleEmote"
    :disabled="isDisabled"
    :title="title"
    :data-tippy-content="tippyContent"
    :class="{
        'user-reacted': userReacted,
        'broadcaster-reacted': broadcasterReacted,
    }"
    class="emote-reaction">
    <Emote
        :emote="emote"
        :alias="alias"
        lazyLoad
        :size="$const.EMOTE_SIZE_IN_REACTION"/>
    <div v-show="count > 1" class="count">
        {{ count | bigNumber }}
    </div>
</button>
</template>

<script>
import * as C from '@shared/constants'
import { mapGetters } from 'vuex'

export default {
    name: 'EmoteReaction',
    props: {
        emoteReaction: Object,
        suggestion: Object,
        canIncrementExistingEmote: Boolean,
    },
    computed: {
        ...mapGetters(['channelName']),
        userReacted: vm => vm.emoteReaction.userReacted,
        broadcasterReacted: vm => vm.emoteReaction.broadcasterReacted,
        emote: vm => vm.emoteReaction.emote,
        alias: vm => vm.emoteReaction.alias || '(unknown emote)',
        count: vm => vm.emoteReaction.count,
        // Let user undo an emote reaction to reduce their count.
        isDisabled: vm => !vm.canIncrementExistingEmote && !vm.userReacted,
        title: vm => (
            vm.isDisabled
                ? `You can only react ${C.MAX_EMOTES_PER_SUGG_PER_USER} times.` : ''
        ),
        tippyContent: vm => (
            vm.broadcasterReacted
                ? `${vm.channelName} reacted with "${vm.alias}"` : vm.alias
        ),
    },
    methods: {
        async toggleEmote () {
            const payload = {
                userReacted: !this.userReacted,
                emote: this.emote,
                suggestionId: this.suggestion.id,
            }
            await this.$store.dispatch('updateEmoteReaction', payload)
            // TODO: Update UI somehow, if this fails. Likely due to hitting
            // the emote quota.
        }
    }
}
</script>

<style lang="scss">
.emote-reaction {
    position: relative;
    display: flex;
    align-items: center;
    padding: $emote-padding;
    margin-right: 2px;
    margin-bottom: 2px;
    height: $emote-size + $emote-padding-vertical * 2;
    background-color: rgba(#eff0f1, 0.75);
    //background-color: green;
    border: none;
    outline: none; // Fuck off chrome.
    border-radius: .25rem;
    font-size: 0.8rem;
    overflow: hidden;
    cursor: pointer;
    transition-property: background-color, opacity, transform;
    transition-duration: $emote-transition-duration;

    .count {
        margin-left: 4px;
    }
    &.hover {

    }
    // A dog ear.
    // https://codepen.io/jagtalon/pen/LpMMgX
    &.broadcaster-reacted:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: inline-block;
        clip-path: polygon(0 0, 0 8px, 8px 0);
        background-color: var(--theme-color);
    }
    &.user-reacted {
        background-color: rgba(#cbd0d6, 0.75);
    }
    &:disabled {
        cursor: not-allowed;
    }
}
</style>
